import CONSTANTS from "./constants";
export const getTabListAction = (payload) => {
  // console.log(payload);
  // console.log("called action--------------------------");
  return {
    type: CONSTANTS.GET_TAB_LIST_DATA,
    payload,
  };
};
export const getCourseDetailsAction = (payload) => {
  // console.log(payload);
  // alert("getCourseDetailsAction")
  // console.log("called action--------------------------", payload);
  return {
    type: CONSTANTS.GET_OVERVIEW_DATA,
    payload,
  };
};
export const getPriceAction = (payload) => {
  // console.log(payload);
  // console.log("called action--------------------------");
  return {
    type: CONSTANTS.GET_COURSE_PRICE,
    payload,
  };
};
export const setPrevOrderId = (payload) => {
  return {
    type: CONSTANTS.SET_PREV_ORDER_ID,
    payload,
  };
};
export const setRetryingPayment = (payload) => {
  return {
    type: CONSTANTS.SET_RETRYING_PAYMENT,
    payload,
  };
};

export const getDynamicCourseListAction = (payload) => {
  return {
    type: CONSTANTS.GET_DYNAMIC_COURSE_LIST,
    payload,
  };
};

export const getDynamicCoursePriceAction = (payload) => {
  return {
    type: CONSTANTS.GET_DYNAMIC_COURSE_PRICE,
    payload,
  };
};

export const setDynamicBundlingSelectedAction = (payload) => {
  return {
    type: CONSTANTS.SET_DYNAMIC_BUNDLING_SELECTED,
    payload,
  };
};
export const getUserDetailsAction = (payload = {}) => {
  return {
    type: CONSTANTS.GET_USER_DETAILS,
    payload,
  };
};
export const setOverviewDataDirectlyInStore = (payload) => {
  return {
    type: CONSTANTS.SET_OVERVIEW_DATA_DIRECTLY_IN_STORE,
    payload,
  };
};
export const getOrgDetailsAction = (payload) => {
  // console.log(payload);
  // console.log("called action--------------------------");
  return {
    type: CONSTANTS.GET_ORG_DETAILS,
    payload,
  };
};
export const postLikeAction = (payload) => {
  // console.log(payload);
  // console.log("called action--------------------------");
  return {
    type: CONSTANTS.POST_LIKE_COURSE,
    payload,
  };
};
export const postLikeResetAction = () => {
  return {
    type: CONSTANTS.POST_LIKE_COURSE_RESET,
  };
};

export const getGraphCoursePriceDetailsAction = (payload) => {
  // console.log('payload+++++source+++++source+++++source', payload);
  return {
    type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS,
    payload,
  };
};

export const getGraphCourseCouponsAction = (payload) => {
  // console.log("payload", payload);
  return {
    type: CONSTANTS.GET_GRAPH_COUPONS_LIST,
    payload,
  };
};

export const applyCourseCouponAction = (payload, checkForMultipleValidity) => {
  return {
    type: CONSTANTS.APPLY_COURSE_COUPON,
    payload,
    checkForMultipleValidity,
  };
};

export const removeCourseCouponAction = (payload) => {
  return {
    type: CONSTANTS.REMOVE_COURSE_COUPON,
    payload,
  };
};

export const applyCouponFakeLoading = (payload) => {
  return {
    type: CONSTANTS.APPLY_COUPON_FAKE_LOADING,
    payload,
  };
};
export const tightOnBudgetBottomSheetCloseAction = (payload) => {
  return {
    type: CONSTANTS.TIGHT_BUDGET_BOTTOMSHEET_CLOSE,
    payload,
  };
};
export const setSelectedStateAction = (payload) => {
  return {
    type: CONSTANTS.SET_SELECTED_STATE,
    payload,
  };
};

export const handleShowCouponAppliedPopup = (payload) => {
  return {
    type: CONSTANTS.APPLY_COUPON_SUCCESS_POPUP,
    payload,
  };
};
export const funnelTrackAction = (payload) => {
  // console.log(payload);

  return {
    type: CONSTANTS.FUNNEL_TRACKING,
    payload,
  };
};
export const funnelTrackHistoryObjectAction = (payload) => {
  // console.log(payload);
  return {
    type: CONSTANTS.FUNNEL_TRACKING_HISTORY_OBJECT,
    payload,
  };
};
export const getIndividualInstallmentAction = (payload) => {
  return {
    type: CONSTANTS.GET_INDIVIDUAL_INSTALLMENT,
    payload,
  };
};

export const setCouponCodeAction = (payload) => {
  return {
    type: CONSTANTS.SET_CURRENT_COUPON_CODE,
    payload,
  };
};

export const updateLikeCourseCountAction = (payload) => {
  return {
    type: CONSTANTS.UPDATE_COURSE_LIKE_COUNT,
    payload,
  };
};

export const updateIsInstallmentPaymentAction = (payload) => {
  return {
    type: CONSTANTS.IS_INSTALLMENT_PAYMENT,
    payload,
  };
};

export const setValidity = (payload) => {
  return {
    type: CONSTANTS.SET_VALIDITY,
    payload,
  };
};

export const showCouponModal = (payload) => {
  return {
    type: CONSTANTS.SHOW_COUPON_MODAL,
    payload,
  };
};

export const setPaymentOptions = (payload) => {
  return {
    type: CONSTANTS.SET_PAYMENT_OPTIONS,
    payload,
  };
};

export const captureInterest = (payload) => {
  return {
    type: CONSTANTS.CAPTURE_INTEREST,
    payload,
  };
};

export const buyNowSuccessModal = (payload) => {
  return {
    type: CONSTANTS.BUY_NOW_SUCCESS_MODAL,
    payload,
  };
};

export const courseFacultyListAction = (payload) => {
  return {
    type: CONSTANTS.GET_COURSE_FACULTY_LIST,
    payload,
  };
};

export const whatsappPaymentLoadingAction = (payload) => {
  return {
    type: CONSTANTS.WHATSAPP_PAYMENT_LOADING,
    payload,
  };
};

export const setComboCourseListAction = (payload) => {
  return {
    type: CONSTANTS.SET_COMBO_COURSE_LIST,
    payload,
  };
};

export const setComboCourseId = (payload) => {
  return {
    type: CONSTANTS.SET_COMBO_COURSE_ID,
    payload,
  };
};

export const setStandAloneUrl = (payload) => {
  return {
    type: CONSTANTS.SET_STANDALONE_URL,
    payload,
  }
}


export const getMoneyBackGuaranteeAction = (payload)=>{
  return {
    type: CONSTANTS.MONEY_BACK_GUARANTEE,
    payload
  }
}


